<h3 mat-dialog-title class="text-uppercase">{{ title }}</h3>
<form *ngIf="(resetPassword || forgotPassword) && passwordForm" [formGroup]="passwordForm"
    (ngSubmit)="onChangePassword()">
    <section mat-dialog-content>
        <div fxLayout="row wrap" fxLayoutGap="16px grid">
            <div fxFlex="100">
                <mat-form-field>
                    <mat-label>Old Password</mat-label>
                    <input type="password" formControlName="AdminPassword" matInput cdkFocusInitial>
                    <mat-hint>Provide old password</mat-hint>
                    <mat-error>Provide old password</mat-error>
                </mat-form-field>
            </div>

            <div fxFlex="100">
                <mat-form-field>
                    <mat-label>New Password</mat-label>
                    <input type="password" formControlName="NewAdminPassword" matInput cdkFocusInitial>
                    <mat-hint>Provide new password</mat-hint>
                    <mat-error>Provide new password</mat-error>
                </mat-form-field>
            </div>

            
            <div fxFlex="100">
                <mat-form-field>
                    <mat-label>Re Type Password</mat-label>
                    <input type="password" formControlName="ReNewAdminPassword" matInput cdkFocusInitial>
                    <mat-hint>Re Type new password</mat-hint>
                    <mat-error>Password do not match</mat-error>
                </mat-form-field>
            </div>
            <!-- <div fxFlex="100">
                <mat-form-field>
                    <mat-label>Confirm New Password</mat-label>
                    <input type="password" formControlName="NewAdminPassword" matInput>
                    <mat-error>Password does not matched</mat-error>
                </mat-form-field>
            </div> -->


            <div fxFlex="100" *ngIf="!isInitial">
                <mat-form-field >
                    <mat-label>Validate OTP</mat-label>
                    <input type="text" size="6" maxlength="6" matInput formControlName="InputOTP">
                    <mat-icon matSuffix>lock_open</mat-icon>
                    <mat-hint align="end">
                        <a href="javascript:void(0);" [ngClass]="{'disabled': !resendOTP}"
                            (click)="resendOTP ? getForgotPassResendOTP() : ''">
                            <span *ngIf="!resendOTP" [innerHTML]="'(00:' + resendOTPTimer + ')'"></span>
                            Resend OTP
                        </a>
                    </mat-hint>
                </mat-form-field>
            </div>



        </div>
    </section>
    <section mat-dialog-actions>
        <div fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap.lt-md="8px">
                <button type="button" fxFlex="35" mat-raised-button mat-button (click)="onCancel()">CANCEL</button>
                <button type="submit" fxFlex="35" mat-raised-button color="primary"
                    [innerHTML]="getSubmitText()"></button>
            </div>
        </div>
    </section>
</form>

<ng-container *ngIf="!resetPassword && !forgotPassword">
    <section mat-dialog-content>
        <div fxLayout="row wrap" fxLayoutGap="16px">
            <mat-selection-list #orgMap fxFlex="100" [multiple]="false">
                <mat-list-option *ngFor="let org of orgList" [selected]="org.OrgCode === selectedOrganization.OrgCode"
                    (click)="onSelectOrg(org)">
                    <!-- <img matListAvatar src="https://via.placeholder.com/100/fff" [@.alt]="org.OrgName"> -->
                    {{org.OrgName}}
                    <mat-icon matListIcon matSuffix *ngIf="checkSelection(org)">check</mat-icon>
                </mat-list-option>
            </mat-selection-list>
        </div>
    </section>
    <section mat-dialog-actions>
        <div fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
                <button fxFlex="40" color="primary" mat-raised-button cdkFocusInitial [disabled]="!selectedOrganization"
                    (click)="onNext()">PROCEED</button>
            </div>
        </div>
    </section>
</ng-container>